import * as yup from 'yup'

const requireStr = yup.string().required("Це обов'язкове поле")
const requireNumber = yup.number().typeError("Це обов'язкове поле").required("Це обов'язкове поле")

export type EditableParty = {
	productName: string
	density: number
	temperature: number
	volume: number
	volumeStableDegree: number
	mass: number
	primePrice: number
}

export const schema: yup.SchemaOf<EditableParty> = yup.object().shape({
	productName: requireStr,
	density: requireNumber,
	temperature: requireNumber,
	volume: requireNumber,
	volumeStableDegree: requireNumber,
	mass: requireNumber,
	primePrice: requireNumber,
	fuelOwner: requireStr,
})
